var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.4999C12.1989 22.4999 12.3896 22.4209 12.5303 22.2802C12.671 22.1396 12.75 21.9488 12.75 21.7499V4.06038L17.469 8.78088C17.6098 8.92171 17.8008 9.00082 18 9.00082C18.1991 9.00082 18.3901 8.92171 18.531 8.78088C18.6718 8.64005 18.7509 8.44904 18.7509 8.24988C18.7509 8.05071 18.6718 7.85971 18.531 7.71888L12.531 1.71888C12.4613 1.64903 12.3785 1.59362 12.2874 1.55581C12.1963 1.518 12.0986 1.49854 12 1.49854C11.9013 1.49854 11.8036 1.518 11.7125 1.55581C11.6214 1.59362 11.5386 1.64903 11.469 1.71888L5.46897 7.71888C5.39924 7.78861 5.34392 7.87139 5.30619 7.9625C5.26845 8.05361 5.24902 8.15126 5.24902 8.24988C5.24902 8.44904 5.32814 8.64005 5.46897 8.78088C5.6098 8.92171 5.80081 9.00082 5.99997 9.00082C6.19913 9.00082 6.39014 8.92171 6.53097 8.78088L11.25 4.06038V21.7499C11.25 21.9488 11.329 22.1396 11.4696 22.2802C11.6103 22.4209 11.8011 22.4999 12 22.4999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsArrowUp);
export default __webpack_public_path__ + "static/media/bsArrowUp.5c59d4f9b2c1f5c4ef096cf370fc2a2b.svg";
export { ForwardRef as ReactComponent };